import { render, staticRenderFns } from "./index.vue?vue&type=template&id=012b6606&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=012b6606&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012b6606",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('012b6606')) {
      api.createRecord('012b6606', component.options)
    } else {
      api.reload('012b6606', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=012b6606&scoped=true", function () {
      api.rerender('012b6606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cases/index.vue"
export default component.exports